import { useEffect } from "react";
import { useNodesInitialized, useReactFlow, useStore } from "@xyflow/react";

export const routeMapFitOptions = { padding: .12, minZoom: .1, maxZoom: 1 };
export const routeMapDuration = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 220;

export const RouteMapViewport = ({ run, ready }) => {
  const initialized = useNodesInitialized();
  const { fitView } = useReactFlow();
  const width = useStore(state => state.width);
  const height = useStore(state => state.height);

  useEffect(() => {
    if (!initialized || !width || !height) return undefined;
    // Wait for measured nodes and the current canvas layout, not an arbitrary streaming timeout.
    // Selection, route inspection and token updates must not override a visitor's pan or zoom.
    const frame = window.requestAnimationFrame(() => {
      fitView({ ...routeMapFitOptions, duration: ready ? routeMapDuration() : 0 });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [initialized, width, height, fitView, run, ready]);

  return null;
};